import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
  ValidatorFn,
  AbstractControl,
  ValidationErrors,
} from "@angular/forms";
import * as SecureLS from "secure-ls";
import { MatSnackBar } from "@angular/material";
import { GlobalVariable } from "src/app/config/global";
import { Donor } from "src/app/model/donor";
import { DonorService } from "src/app/service/donor.service";
import { DnitypeService } from "src/app/service/dnitype.service";
import { DNIType } from "src/app/model/dniType";
import { UnionService } from "src/app/service/union.service";
import { BusinessunitService } from "src/app/service/businessunit.service";
import { ChurchService } from "src/app/service/church.service";
import { DistrictService } from "src/app/service/district.service";
import { BusinessUnit } from "src/app/model/businessUnit";
import { Church } from "src/app/model/church";
import { District } from "src/app/model/district";
import { Union } from "src/app/model/union";
import { EcclesiaService } from "src/app/service/ecclesia.service";
import { customEmailValidator } from "src/app/utils/email.customvalidator";

@Component({
  selector: "app-signup",
  templateUrl: "./signup.component.html",
  styleUrls: ["./signup.component.scss"],
})
export class SignupComponent implements OnInit {
  AppName = GlobalVariable.APP_NAME;
  isLoading = false;
  errorMessage = "";
  signupForm: FormGroup;

  // model
  dniTypes: DNIType[];
  selectedDNIType = <DNIType>{
    id: "",
  };
  unions: Union[] = [];
  selectedUnion = <Union>{
    id: "",
  };
  businessUnits: BusinessUnit[] = [];
  selectedBusinessUnit = <BusinessUnit>{
    id: "",
  };
  districts: District[];
  selectedDistrict = <District>{
    id: "",
  };
  churchs: Church[];
  selectedChurch = <Church>{
    id: "",
  };
  // alfoli
  businessUnitsAlfoli: BusinessUnit[] = [];
  districtsAlfoli: District[];
  churchsAlfoli: Church[];
  // ecclesia
  unionsEcclesia: Union[] = [];
  selectedUnionEcclesia = <Union>{
    id: "",
  };
  unionEcclesiaKeyMap = { nombre: "short_name" };
  businessUnitsEcclesia: BusinessUnit[] = [];
  selectedBusinessUnitEcclesia = <BusinessUnit>{
    id: "",
  };
  districtsEcclesia: District[] = [];
  selectedDistrictEcclesia = <District>{
    id: "",
  };
  districtsEcclesiaByBU: District[] = [];
  districtEcclesiaKeyMap = {
    asociacionId: "bu_code",
    distritoId: "district_id",
    descripcion: "code",
    nombre: "name",
    activo: "status",
    asociacionNombre: "bu_name",
    unionId: "union_code",
    unionNombre: "union_short_name",
  };
  churchsEcclesia: Church[] = [];
  selectedChurchEcclesia = <Church>{
    id: "",
  };
  churchsEcclesiaByDistrict: Church[] = [];
  churchEcclesiaKeyMap = {
    asociacionId: "bu_code",
    distritoId: "district_id",
    descripcion: "code",
    nombre: "name",
    activo: "status",
    direccion: "address",
    tesorero: "treasurer_name",
    distritoNombre: "district_name",
    asociacionNombre: "bu_name",
    unionId: "union_code",
    unionNombre: "union_short_name",
    ciudad: "city_name",
  };
  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    public snackBar: MatSnackBar,
    private dnitypeService: DnitypeService,
    private unionService: UnionService,
    private businessunitService: BusinessunitService,
    private districtService: DistrictService,
    private churchService: ChurchService,
    private donorService: DonorService,
    private ecclesiaService: EcclesiaService
  ) {
    this.setAllUnions();
  }

  ngOnInit() {
    this.initForms();
    this.getDNITypes();
    this.setUnion();
  }

  initForms() {
    this.signupForm = this.formBuilder.group(
      {
        email: new FormControl("", [Validators.required, customEmailValidator]),
        reemail: new FormControl("", [
          Validators.required,
          customEmailValidator,
        ]),
        password: new FormControl("", [
          Validators.required,
          Validators.pattern("\\s*(\\S\\s*){6,}"),
        ]),
        repassword: new FormControl("", [
          Validators.required,
          Validators.pattern("\\s*(\\S\\s*){6,}"),
        ]),
        dniType: new FormControl("", [Validators.required]),
        dni: new FormControl("", [
          Validators.required,
          Validators.pattern("\\s*(\\S\\s*){6,}"),
        ]),
        firstName: new FormControl("", [Validators.required]),
        middleName: new FormControl(""),
        lastName: new FormControl("", [Validators.required]),
        secondLastName: new FormControl(""),
        orgName: new FormControl("", [Validators.required]),
        address: new FormControl("", [Validators.required]),
        phoneNumber: new FormControl("", [
          Validators.required,
          Validators.pattern("\\s*(\\S\\s*){7,}"),
        ]),
        taxFiler: new FormControl("", [Validators.required]),
        certificate: new FormControl("", [Validators.required]),
        union: new FormControl("", [Validators.required]),
        bu: new FormControl("", [Validators.required]),
        district: new FormControl("", [Validators.required]),
        church: new FormControl("", [Validators.required]),
        privacy: new FormControl(false, [Validators.requiredTrue]),
      },
      {
        validators: [
          this.ConfirmedValidator("email", "reemail"),
          this.ConfirmedValidator("password", "repassword"),
        ],
      }
    );
  }

  ConfirmedValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (
        matchingControl.errors &&
        !matchingControl.errors.confirmedValidator
      ) {
        return;
      }
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ confirmedValidator: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  getErrorMessage(component: string) {
    let errorMessage = "";
    switch (component) {
      case "email":
        errorMessage = this.signupForm.get("email").hasError("required")
          ? "campo requerido"
          : this.signupForm.get("email").hasError("invalidEmail")
          ? "ingresa un correo válido"
          : "";
        break;
      case "reemail":
        errorMessage = this.signupForm.get("reemail").hasError("required")
          ? "debe confirmar su correo electrónico"
          : this.signupForm.get("reemail").hasError("invalidEmail")
          ? "ingresa un correo válido"
          : "";
        break;
      case "password":
        errorMessage = this.signupForm.get("password").hasError("required")
          ? "debe ingresar su contraseña"
          : this.signupForm.get("password").hasError("pattern")
          ? "mínimo 6 caracteres"
          : "";
        break;
      case "repassword":
        errorMessage = this.signupForm.get("repassword").hasError("required")
          ? "debe confirmar su contraseña"
          : this.signupForm.get("repassword").hasError("pattern")
          ? "mínimo 6 caracteres"
          : "";
        break;
      case "dni":
        errorMessage = this.signupForm.get("dni").hasError("required")
          ? "debe ingresar su número de identificación"
          : this.signupForm.get("dni").hasError("pattern")
          ? "mínimo 6 caracteres"
          : "";
        break;
      case "dniType":
        errorMessage = this.signupForm.get("dniType").hasError("required")
          ? "debe seleccionar un tipo de documento"
          : "";
        break;
      case "phoneNumber":
        errorMessage = this.signupForm.get("phoneNumber").hasError("required")
          ? "debe ingresar un número de teléfono"
          : this.signupForm.get("phoneNumber").hasError("pattern")
          ? "mínimo 7 caracteres"
          : "";
        break;
      case "taxFiler":
        errorMessage = this.signupForm.get("taxFiler").hasError("required")
          ? "debe seleccionar una opción"
          : "";
        break;
      case "certificate":
        errorMessage = this.signupForm.get("certificate").hasError("required")
          ? "debe seleccionar una opción"
          : "";
        break;
      case "union":
        errorMessage = this.signupForm.get("union").hasError("required")
          ? "debe seleccionar su unión"
          : "";
        break;
      case "bu":
        errorMessage = this.signupForm.get("bu").hasError("required")
          ? "debe seleccionar su campo"
          : "";
        break;
      case "district":
        errorMessage = this.signupForm.get("district").hasError("required")
          ? "debe seleccionar su distrito"
          : "";
        break;
      case "church":
        errorMessage = this.signupForm.get("church").hasError("required")
          ? "debe seleccionar su iglesia"
          : "";
        break;
      case "privacy":
        errorMessage = this.signupForm.get("privacy").hasError("required")
          ? "Debe aceptar términos y condiciones para poder continuar"
          : "";
        break;
    }
    return errorMessage;
  }

  getDNITypes() {
    this.isLoading = true;
    this.dnitypeService.get().subscribe(
      (p) => {
        this.dniTypes = p.results !== undefined ? p.results : [];
      },
      (e) => this.launchMessage(e),
      () => {
        this.isLoading = false;
        if (this.dniTypes.length > 0) {
        }
      }
    );
  }

  /** Event handler when district select component changes */
  dniTypesSelectionChange(event: { value: DNIType }) {
    this.selectedDNIType = event.value;
    if (this.selectedDNIType.id !== "31") {
      this.signupForm.controls["orgName"].setValidators([]);
      this.signupForm.controls["orgName"].updateValueAndValidity();
      this.signupForm.controls["firstName"].setValidators([
        Validators.required,
      ]);
      this.signupForm.controls["firstName"].updateValueAndValidity();
      this.signupForm.controls["lastName"].setValidators([Validators.required]);
      this.signupForm.controls["lastName"].updateValueAndValidity();
    } else {
      this.signupForm.controls["firstName"].setValidators([]);
      this.signupForm.controls["firstName"].updateValueAndValidity();
      this.signupForm.controls["lastName"].setValidators([]);
      this.signupForm.controls["lastName"].updateValueAndValidity();
      this.signupForm.controls["orgName"].setValidators([Validators.required]);
      this.signupForm.controls["orgName"].updateValueAndValidity();
    }
  }

  getAllUnion() {
    this.isLoading = true;
    this.unionService.get().subscribe(
      (p) => {
        this.unions = p.results !== undefined ? p.results : [];
      },
      (e) => this.launchMessage(e),
      () => {
        this.isLoading = false;
        if (this.unions.length > 0) {
        }
      }
    );
  }

  /** Function to set local union list for select */
  setAllUnions() {
    this.unions = [
      {
        id: "3",
        short_name: "Union Colombiana del Norte",
        name: "Union Colombiana del Norte",
        location: "Colombia",
        division_code: "SUD",
      },
      {
        id: "5",
        short_name: "Union Colombiana del Sur",
        name: "Union Colombiana del Sur",
        location: "Colombia",
        division_code: "SUD",
      },
    ];
  }

  /** Event handler when business unit select component changes */
  unionSelectionChange(event: { value: Union }) {
    this.selectedUnion = event.value;
    // this.signupForm.controls["bu"].setValue(null);
    // this.signupForm.controls["district"].setValue(null);
    // this.signupForm.controls["church"].setValue(null);
    // this.businessUnits = [];
    // this.districts = [];
    // this.churchs = [];
    // this.getBusinessUnitByUnion();
    if (this.selectedUnion.id === "5") {
      window.location.href = "https://mialfoliadventista.org/signup";
    }
  }

  setUnion() {
    this.selectedUnion = <Union>{
      id: "3",
      short_name: "Union Colombiana del Norte",
    };
    this.getBusinessUnitByUnion();
  }

  getBusinessUnitByUnion() {
    this.isLoading = true;
    var response = [];
    this.businessunitService.getByUnion("AGC111").subscribe(
      (p) => {
        response = p.results !== undefined ? p.results : [];
      },
      (e) => this.launchMessage(e),
      () => {
        this.isLoading = false;
        this.businessUnitsAlfoli = response;
        this.getChurchsByUnionEclessia();
      }
    );
  }

  getChurchsByUnionEclessia() {
    this.isLoading = true;
    var response = [];
    this.ecclesiaService.getChurchsByUnion(this.selectedUnion.id).subscribe(
      (p) => {
        response = p.listaItems !== undefined ? p.listaItems : [];
      },
      (e) => this.launchMessage(e),
      () => {
        // change object keys
        this.churchsEcclesia = this.renameKeys(
          response,
          this.churchEcclesiaKeyMap
        );
        this.setBusinessUnitsEcclesia();
        this.isLoading = false;
      }
    );
  }

  setBusinessUnitsEcclesia() {
    if (this.churchsEcclesia.length > 0) {
      // business units
      const uniqueDataBusinessUnits = this.removeDuplicates(
        this.churchsEcclesia,
        "bu_code"
      );
      uniqueDataBusinessUnits.forEach((church) => {
        const buAlfoli = this.businessUnitsAlfoli.find(
          (bu) => bu.ecclesia7_id === church.bu_code
        );
        this.businessUnitsEcclesia.push({
          id: church.bu_code,
          name: church.bu_name,
          short_name: church.bu_name,
          national_code: "",
          email: buAlfoli ? buAlfoli.email : "",
          address: "",
          phone: "",
          telefax: "",
          website: "",
          location: "",
          resolution: "",
          accountant: "",
          accountant_code: "",
          payment_publickey: buAlfoli ? buAlfoli.payment_publickey : "",
          payment_secretkey: "",
          payment_integrity: buAlfoli ? buAlfoli.payment_integrity : "",
          ecclesia7_id: church.bu_code,
          type: "ecclesia",
        });
      });
      this.mergeBusinessUnitsAlfoliEcclesia();
    }
  }

  mergeBusinessUnitsAlfoliEcclesia() {
    this.businessUnits = [
      ...this.businessUnitsEcclesia,
      ...this.businessUnitsAlfoli.filter((bu) => bu.displayed_alfoli === "1"),
    ];
  }

  /** Event handler when business unit select component changes */
  buSelectionChange(event: { value: BusinessUnit }) {
    this.selectedBusinessUnit = event.value;
    this.signupForm.controls["district"].setValue(null);
    this.signupForm.controls["church"].setValue(null);
    this.districtsAlfoli = [];
    this.districtsEcclesia = [];
    this.districtsEcclesiaByBU = [];
    this.districts = [];
    this.churchs = [];
    this.getDistricsByBU();
  }

  getDistricsByBU() {
    this.isLoading = true;
    this.districtService.getByBU(this.selectedBusinessUnit.id).subscribe(
      (p) => {
        this.districtsAlfoli = p.results !== undefined ? p.results : [];
      },
      (e) => this.launchMessage(e),
      () => {
        this.isLoading = false;
        this.districtsAlfoli = [];
        this.getDistrictsEcclesia();
      }
    );
  }

  getDistrictsEcclesia() {
    this.isLoading = true;
    var response = [];
    this.ecclesiaService
      .getDistrictsByUnionAndBU(
        this.selectedUnion.id,
        this.selectedBusinessUnit.id
      )
      .subscribe(
        (p) => {
          response = p.listaItems !== undefined ? p.listaItems : [];
        },
        (e) => this.launchMessage(e),
        () => {
          // change object keys
          this.districtsEcclesiaByBU = this.renameKeys(
            response,
            this.districtEcclesiaKeyMap
          );
          this.mergeDistricsAlfoliEcclesia();
          this.isLoading = false;
        }
      );
  }

  setDistricsEcclesia() {
    if (this.churchsEcclesia.length > 0) {
      // districts
      const uniqueDataDistricts = this.removeDuplicates(
        this.churchsEcclesia,
        "district_id"
      );
      uniqueDataDistricts.forEach((church) => {
        this.districtsEcclesia.push({
          id: church.district_id,
          code: "",
          name: church.district_name,
          status: "",
          bu_code: church.bu_code,
        });
      });
    }
    if (this.districtsEcclesia.length > 0) {
      this.districtsEcclesiaByBU = this.districtsEcclesia.filter(
        (district) => district["bu_code"] === this.selectedBusinessUnit.id
      );
    }
    this.mergeDistricsAlfoliEcclesia();
  }

  mergeDistricsAlfoliEcclesia() {
    this.districts = [...this.districtsEcclesiaByBU, ...this.districtsAlfoli];
  }

  /** Event handler when district select component changes */
  districtSelectionChange(event: { value: District }) {
    this.selectedDistrict = event.value;
    this.signupForm.controls["church"].setValue(null);
    this.churchs = [];
    this.selectedChurch = null;
    this.getChurchsByDistrict();
  }

  getChurchsByDistrict() {
    this.isLoading = true;
    this.churchService.getByDistrict(this.selectedDistrict.id).subscribe(
      (p) => {
        this.churchsAlfoli = p.results !== undefined ? p.results : [];
      },
      (e) => this.launchMessage(e),
      () => {
        this.isLoading = false;
        this.churchsAlfoli = [];
        this.setChurchsEcclesia();
      }
    );
  }

  setChurchsEcclesia() {
    if (this.churchsEcclesia.length > 0) {
      this.churchsEcclesiaByDistrict = this.churchsEcclesia.filter(
        (church) => church["district_id"] === this.selectedDistrict.id
      );
    }
    this.mergeChurchsAlfoliEcclesia();
  }

  mergeChurchsAlfoliEcclesia() {
    this.churchs = [...this.churchsEcclesiaByDistrict, ...this.churchsAlfoli];
  }

  /** Event handler when church select component changes */
  churchSelectionChange(event: { value: Church }) {
    this.selectedChurch = event.value;
  }

  createDonor(form: FormGroup) {
    let message = "";
    const submission = this.buildJSONToPostDonor();
    this.donorService.post(submission).subscribe(
      (p) => (message = p.message),
      (e) =>
        this.launchMessage(
          "El registro no se pudo procesar en estos momentos. Por favor intente nuevamente"
        ),
      () => {
        this.isLoading = false;
        if (message === "Donor was created") {
          this.launchMessage("Registro realizado con éxito.");
          this.router.navigate(["/validatecode"]);
        } else if (message === "Donor exists") {
          this.launchMessage(
            "Ya existe un usuario con este correo o número de documento. Por favor intente con uno diferente"
          );
        } else {
          this.launchMessage(
            "El registro no se pudo procesar en estos momentos. Por favor intente nuevamente"
          );
        }
      }
    );
  }

  /** this method builds the json using the data enter in the form and selected assets */
  buildJSONToPostDonor(): any {
    const x = {
      id: this.signupForm.value.dni,
      dni_type: this.signupForm.value.dniType.id,
      email: this.signupForm.value.email,
      password: encodeURIComponent(window.btoa(this.signupForm.value.password)),
      firstname: this.signupForm.value.firstName,
      middlename: this.signupForm.value.middleName,
      first_lastname: this.signupForm.value.lastName,
      second_lastname: this.signupForm.value.secondLastName,
      org_name: this.signupForm.value.orgName,
      address: this.signupForm.value.address,
      cellphone: this.signupForm.value.phoneNumber,
      tax_filer: this.signupForm.value.taxFiler,
      certificate: this.signupForm.value.certificate,
      union_code: this.selectedUnion.id,
      bu_code: this.selectedBusinessUnit.id,
      district_id: this.selectedDistrict.id,
      church_id: this.selectedChurch.id,
    };
    return x;
  }

  /** function that rename the keys from all the objects of an array */
  renameKeys(array, keyMap) {
    return array.map((obj) => {
      const newObj = {};
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          const newKey = keyMap[key] || key;
          newObj[newKey] = obj[key];
        }
      }
      return newObj;
    });
  }

  /** function thata remove duplicate objects from an array based on a key */
  removeDuplicates(array, key) {
    return array.filter(
      (obj, index, self) => index === self.findIndex((o) => o[key] === obj[key])
    );
  }

  /** Joins emails from tesoreroItems array into a single string */
  joinEmails(tesoreroItems: any[]): string {
    if (!tesoreroItems || !Array.isArray(tesoreroItems)) {
      return "";
    }
    return tesoreroItems
      .map((item) => (item && item.email ? item.email : ""))
      .filter((email) => email)
      .join("; ");
  }

  /** Launch message of the snackBar component */
  launchMessage(message: string) {
    this.errorMessage = "";
    this.isLoading = false;
    const action = "OK";
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }
}
